// Page-view logging for Admin -> Viewing (reports db/112, 2026-10-19).
//
// reportPageView(path, view?) posts one row to /api/me/page-view. The App's
// PageViewTracker calls it on every route change; tabs with an in-page switch
// (Customer Service) call it with their sub-view so the Viewing tab can tell
// "Customer Service › Comps" from "Customer Service › Members". A repeat of the
// same key inside 60 s is skipped here (and again server-side). Failures are
// silent — logging must never get in the way of the page.

let lastKey = '';
let lastAt = 0;

export function reportPageView(path: string, view?: string | null): void {
  try {
    if (!path || !path.startsWith('/')) return;
    if (path.startsWith('/pullman-offline') || path.startsWith('/pullman-live')) return // offline-first tab: no network assumptions
    const key = `${path}|${view ?? ''}`;
    const now = Date.now();
    if (key === lastKey && now - lastAt < 60_000) return;
    lastKey = key; lastAt = now;
    void fetch('/api/me/page-view', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ path, view: view ?? null }),
      keepalive: true,
      credentials: 'include',
    }).catch(() => undefined);
  } catch { /* never throw from logging */ }
}
